var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPregnantWoman(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pregnant_woman_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1997",
    "data-name": "Group 1997"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3328",
    "data-name": "Rectangle 3328",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2000",
    "data-name": "Group 2000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1999",
    "data-name": "Group 1999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1998",
    "data-name": "Group 1998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8333",
    "data-name": "Path 8333",
    d: "M9,4a2,2,0,1,1,2,2A1.993,1.993,0,0,1,9,4Zm7,9a3.285,3.285,0,0,0-2-3,3,3,0,0,0-6,0v7h2v5h3V17h3Z",
    fill: "#f8f9ff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPregnantWoman);
export default __webpack_public_path__ + "static/media/pregnant_woman.1f082e758f3b3f82145212ccb13c7e7f.svg";
export { ForwardRef as ReactComponent };